var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vmdtp_header"},[_c('p',{staticClass:"vmdtp_text vmdtp_text--year"},[_vm._v(_vm._s(_vm.year))]),_c('p',{staticClass:"vmdtp_text vmdtp_text--month"},[_vm._v(_vm._s(_vm.dateText))])])}
var staticRenderFns = []

export { render, staticRenderFns }